// extracted by mini-css-extract-plugin
module.exports = {"button":"students_button__35YZG"};